<template>
    <div class="hts-monitoring-vehicle__container h-full">
        <div class="container-left show">
            <div class="flex-initial box-border p-2">
                <div class="w-full">
                    <hts-form-input
                        v-model="vehicleFilters.search"
                        class="w-full mt-1"
                        :placeholder="$t('labels.findVehicle')">
                        <template #prefix>
                            <hts-icons
                                icon-name="hi-magnifying-glass-icon"
                                class="text-gray-500" />
                        </template>
                    </hts-form-input>
                    <div>
                        <hts-filter-toggle
                            v-model="vehicleFilters.processStatus"
                            :items="vehicleStatuses"
                            label="Trạng thái vận hành"
                            class="mt-1 mr-1" />
                        <hts-filter-toggle
                            v-model="vehicleFilters.vehicleType"
                            :items="vehicleTypes"
                            label="Loại phương tiện"
                            class="mt-1" />
                    </div>
                </div>
                <div
                    v-if="false"
                    class="w-full">
                    <hts-filter-toggle
                        v-model="vehicleFilters.infoType"
                        icon-name="hi-eye-icon"
                        :clearable="false"
                        :items="[
                            { value: 'vehicle', label: 'Xe' },
                            { value: 'journey', label: 'Chặng' },
                            { value: 'status', label: 'Trạng thái' }
                        ]"
                        label="Thông tin"
                        class="mt-1 mr-1" />
                </div>
            </div>

            <div
                v-loading="vehicleLoading"
                class="content overflow-hidden">
                <div class="flex gap-2 items-center p-2 font-bold bg-white border-b">
                    <div class="flex-1">
                        Biển số
                    </div>
                    <div class="flex-1">
                        Thông tin
                    </div>
                </div>
                <div class="h-full relative overflow-auto">
                    <vehicle-list
                        :items="vehicles"
                        :filters="vehicleFilters"
                        @selected="handleSelectVehicle" />
                </div>
            </div>
        </div>

        <div class="container-right">
            <schedule-map
                v-if="showMap"
                ref="scheduleMap"
                class="min-h-[40%]"
                :show-location="showMapLocation"
                :journey="selectedJourney" />

            <div class="journey">
                <div class="flex items-center justify-between gap-1">
                    <div class="flex flex-wrap items-center gap-1">
                        <hts-filter-toggle
                            v-model="journeyFilters.processStatus"
                            :items="statuses"
                            label="Trạng thái cảnh báo vận hành" />
                        <hts-filter-toggle
                            v-model="journeyFilters.vehicleType"
                            :items="vehicleTypes"
                            label="Loại phương tiện" />
                        <hts-filter-toggle
                            v-model="journeyFilters.scheduleType"
                            :items="scheduleTypes"
                            label="Điều phối" />
                        <hts-filter-toggle
                            v-model="journeyFilters.processingType"
                            :items="processingTypes"
                            label="Trạng thái vận hành" />
                    </div>
                    <div class="flex items-center gap-3">
                        <hts-form-input
                            v-model="journeyFilters.search"
                            class="flex-initial w-72"
                            :placeholder="$t('labels.findJourney')">
                            <template #prefix>
                                <hi-magnifying-glass-icon class="h-6 w-6 ml-2 text-gray-500" />
                            </template>
                        </hts-form-input>
                        <div class="flex gap-3">
                            <hts-map-icon-location store-key="monitoringOwner" />
                            <hts-map-icon-map store-key="monitoringOwner" />
                        </div>
                    </div>
                </div>
                <div class="mt-3">
                    <hts-data-table
                        ref="dataTable"
                        class="w-full"
                        :custom-style="{ 'min-height': '300px' }"
                        :headers="headers"
                        :server="server"
                        :query-extend="queryExtend"
                        row-selection="single"
                        enable-cell-change-flash
                        @selection-changed="handleJourneySelectedChange"
                        @row-click="handleRowClick" />
                </div>
            </div>
        </div>
        <journey-info
            ref="journeyInfoComponent"
            :api="$url.monitoring.journey.getDetail"
            :exclude="journeyInfoExclude" />
    </div>
</template>

<script setup lang="ts">
import JourneyInfo from '../-components/journey-info.vue'
import ScheduleMap from '../journey/-components/journey-schedule/map.vue'
import AlertStatus from './-components/alert-status.vue'
import VehicleList from './-components/vehicle-list.vue'

const { $event, $formatters } = useNuxtApp()
const { monitoringPage, map } = $store()
const company = computed(() => $store().system.getCompany)
const dataTable = ref<any>()
const journeyInfoComponent: any = ref(null)
const alertListComponent: any = ref(null)
const alertNumber = ref(0)
const selectedJourney = ref<any>(undefined)
const server = $url.monitoring.journey.get
const queryExtend = computed(() => {
  return {
    vehicleId: selectedVehicleId.value,
    processAlertStatus: journeyFilters.value.processStatus,
    scheduleType: journeyFilters.value.scheduleType,
    vehicleType: journeyFilters.value.vehicleType,
    processingType: journeyFilters.value.processingType,
    search: journeyFilters.value.search
  }
})
const journeyInfoExclude = computed<any[]>(() => ['time'])
const vehicleLoading = ref(false)
const vehicles = ref<any[]>([])
const vehicleLength = computed(() => vehicles.value.length)
const vehicleFilters = computed({
  get: () => monitoringPage.getVehicleFilters,
  set: (val: any) => {
    monitoringPage.setVehicleFilters(val)
  }
})
const journeyFilters = computed({
  get: () => monitoringPage.getJourneyFilters,
  set: (val: any) => {
    monitoringPage.setJourneyFilters(val)
  }
})

onBeforeMount(() => {
  map.setShowLocation({ monitoringOwner: false })
  map.setShowMap({ monitoringOwner: true })
})

const vehicleStatuses = ref([
  {
    label: 'Đang chờ',
    value: 0
  },
  {
    label: 'Đang chạy',
    value: 1
  }
])
const statuses = ref([
  {
    svg: 'operation',
    iconColor: '#facc15',
    label: 'Vàng',
    value: 1
  },
  {
    svg: 'operation',
    iconColor: 'red',
    label: 'Đỏ',
    value: 2
  },
  {
    svg: 'operation',
    iconColor: 'green',
    label: 'Xanh',
    value: 0
  }
])
const vehicleTypes = ref([
  {
    label: 'Xe container',
    value: 'container'
  },
  {
    label: 'Xe không container',
    value: 'non_container'
  }
])
const scheduleTypes = ref([
  {
    label: 'Manual',
    value: 'manual'
  },
  {
    label: 'Automation',
    value: 'auto'
  }
])
const processingTypes = ref([
  {
    label: 'Đang thực hiện',
    value: 'in_progress'
  },
  {
    label: 'Chờ khởi hành',
    value: 'waiting_start'
  },
  {
    label: 'Quá thời gian khởi hành (dự kiến)',
    value: 'over_start_at'
  }
])
const route = useRoute()

onBeforeMount(() => {
  eventListening()
})

onMounted(() => {
  if (route.query.journeyId) {
    openView({ _id: route.query.journeyId })
  }
  getVehicles()
})
watch(
  () => route.query.journeyId,
  (val: any) => {
    openView({ _id: val })
  }
)
watch(
  () => vehicleFilters.value.search,
  (val: string) => {
    getVehiclesDebounce(true)
  }
)
watch(
  () => vehicleFilters.value.processStatus,
  (val: string) => {
    getVehiclesDebounce(true)
  }
)
watch(
  () => vehicleFilters.value.vehicleType,
  (val: string) => {
    getVehiclesDebounce(true)
  }
)
watch(
  () => journeyFilters.value.search,
  (val: string) => {}
)
watch(
  () => journeyFilters.value.processStatus,
  (val: any) => {
    refreshTable()
  }
)
watch(
  () => journeyFilters.value.scheduleType,
  (val: any) => {
    refreshTable()
  }
)
watch(
  () => journeyFilters.value.vehicleType,
  (val: any) => {
    refreshTable()
  }
)
watch(
  () => journeyFilters.value.processingType,
  (val: any) => {
    refreshTable()
  }
)
watch(
  () => journeyFilters.value.search,
  (val: any) => {
    refreshTable()
  }
)
const refreshTable = $lodash.debounce(() => {
  dataTable.value && dataTable.value.refresh()
}, 300)

const getVehicles = (clear: boolean = false) => {
  vehicleLoading.value = true
  if (clear) {
    vehicles.value = []
  }
  $api($url.monitoring.vehicle.get, {
    body: {
      skip: vehicleLength.value,
      search: vehicleFilters.value.search,
      processStatus: vehicleFilters.value.processStatus,
      vehicleType: vehicleFilters.value.vehicleType
    }
  })
    .then(({ data }: any) => {
      const temp = (data?.value || {}).data || []
      if (Array.isArray(temp)) {
        vehicles.value = [...vehicles.value, ...temp]
      }
      vehicleLoading.value = false
    })
    .catch(() => {
      vehicleLoading.value = false
    })
}
const getVehiclesDebounce = $lodash.debounce(getVehicles, 500)

const getJourney = async (id: string) => {
  const response = await $api($url.monitoring.journey.getDetail, { uriParams: { ID: id } })
  const { data } = response
  return (data?.value || {}).data || {}
}

const eventListening = () => {
  $event.listen(`c-${company.value._id}-journey-change`, async (event: any) => {
    const { message } = event || {}
    const { journeyId, changes } = message || {}
    if (journeyId) {
      journeyInfoComponent.value && journeyInfoComponent.value.refresh(journeyId)
      dataTable.value && dataTable.value.setItem(journeyId, await getJourney(journeyId))
      alertNumber.value++
    }
  })
  $event.listen(`c-${company.value._id}-vehicle-change`, ({ id, type, location, journey, status, processStatus }: any) => {
    //
  })
}

const handleJourneySelectedChange = (journeys: any) => {
  const positions = journeys?.value?.[0]?.journey
  try {
    let check = true
    if (positions?.length) {
      if (!positions[0].lat || !positions[0].lng) {
        check = false
      }
      const origin = {
        lat: parseFloat(positions[0].lat),
        lng: parseFloat(positions[0].lng)
      }
      positions.splice(0, 1)
      if (!positions[positions.length - 1].lat || !positions[positions.length - 1].lng) {
        check = false
      }
      const destination = {
        lat: parseFloat(positions[positions.length - 1].lat),
        lng: parseFloat(positions[positions.length - 1].lng)
      }
      positions.splice(positions.length - 1, 1)
      const waypoints: { location: google.maps.LatLngLiteral }[] = []
      positions.forEach((position: any) => {
        if (!position.lat || !position.lng) {
          check = false
        }
        const waypoint = {
          location: {
            lat: parseFloat(position.lat),
            lng: parseFloat(position.lng)
          }
        }
        waypoints.push(waypoint)
      })

      // if (check) {
      //   journeyRoute.value = {
      //     originData: origin,
      //     destinationData: destination,
      //     waypointsData: waypoints
      //   }
      // } else {
      //   journeyRoute.value = null
      // }
    }
  } catch (e) {}
}

const handleRowClick = (data: any) => {
  if (selectedJourney.value?._id === data._id) {
    return
  }
  selectedJourney.value = data
}

const openView = (row: any) => {
  journeyInfoComponent.value && journeyInfoComponent.value.show(row._id)
}

const showAlertList = () => {
  alertNumber.value = 0
  alertListComponent.value && alertListComponent.value.show()
}

const selectedVehicleId = ref<any>(null)
const handleSelectVehicle = (vehicle: any) => {
  if (!vehicle || !vehicle._id) {
    selectedVehicleId.value = null
    refreshTable()
    return
  }
  setMapCenter(vehicle)
  selectedVehicleId.value = vehicle._id
  refreshTable()
}

const showMap = computed(() => {
  return map.getShowMap.monitoringOwner
})
const showMapLocation = computed(() => {
  return map.getShowLocation.monitoringOwner
})

watch(
  () => showMap.value,
  (val: boolean) => {
    dataTable.value && dataTable.value.onResized()
  }
)
const headers = ref([
  {
    field: 'processAlertStatus',
    headerName: 'Cảnh báo',
    sortable: false,
    lockPosition: true,
    lockPinned: true,
    suppressMovable: true,
    resizable: false,
    minWidth: 125,
    maxWidth: 125,
    cellClass: 'cell-no-padding',
    cellRenderer: AlertStatus,
    filter: 'TableFilterStatus',
    filterItems: [
      { name: $t('labels.all'), value: null },
      { name: '', svg: 'warning-sign', iconColor: 'green', value: [0, 29] },
      { name: '', svg: 'warning-sign', iconColor: 'red', value: [30, 100] }
    ],
    filterModelDefault: { type: 'inRange', filterType: 'number' }
  },
  {
    field: 'code',
    headerName: $t('labels.code'),
    sortable: true,
    filter: 'agTextColumnFilter'
  },
  {
    field: 'journeyName',
    headerName: $t('labels.journey2'),
    valueGetter: (params: any) => {
      const journeyName = params?.data.journeyName
      if (typeof journeyName === 'string') {
        return journeyName
      }
      if (Array.isArray(journeyName)) {
        return journeyName.join(' >>> ')
      }
      return ''
    }
  },
  {
    field: 'transportation',
    sortable: true,
    headerName: $t('labels.transportation'),
    valueGetter: (params: any) => {
      const transportation = params?.data.orderData?.transportation
      if (transportation === 'CONTAINER') {
        return $t('labels.containerTruck')
      }
      if (transportation === 'NON_CONTAINER') {
        return $t('labels.nonContainerTruck')
      }
    }
  },
  {
    field: 'mergeContainer',
    headerName: $t('labels.mergeContainer'),
    valueGetter: (params: any) => {
      const mergeContainer = params?.data?.orderData?.mergeContainer
      if (mergeContainer) {
        return $t('labels.haveMergeContainer')
      }
      return $t('labels.notMergeContainer')
    }
  },
  {
    field: 'headContainer',
    headerName: $t('labels.headContainer'),
    valueGetter: (params: any) => {
      const headContainer = params?.data?.orderData?.headContainer
      if (headContainer) {
        return $t('labels.true')
      }
      return $t('labels.false')
    }
  },
  {
    field: 'commodityName',
    headerName: $t('labels.commodity'),
    valueGetter: (params: any) => {
      const commodityName = params?.data?.orderData?.commodityName
      const commodityCategory = params?.data?.orderData?.commodityCategory
      if (commodityName && commodityCategory) {
        return `${commodityName} - ${commodityCategory}`
      }
      if (commodityName) {
        return commodityName
      }
      return ''
    }
  },
  {
    field: 'etd',
    headerName: $t('labels.etd'),
    sortable: true,
    filter: 'agDateColumnFilter',
    valueGetter: (params: any) => {
      return $formatters.datetime(params.data.startAt)
    }
  },
  {
    field: 'eta',
    headerName: $t('labels.eta'),
    sortable: true,
    filter: 'agDateColumnFilter',
    valueGetter: (params: any) => {
      return $formatters.datetime(params.data.stopAt)
    }
  },
  {
    field: 'note',
    headerName: $t('labels.note')
  },
  {
    field: 'action',
    pinned: 'right',
    sortable: false,
    lockPosition: true,
    lockPinned: true,
    suppressMenu: true,
    suppressMovable: true,
    resizable: false,
    headerName: $t('labels.action'),
    headerClass: 'ag-header-text-center',
    cellStyle: { overflow: 'visible' },
    cellRenderer: 'DataTableActions',
    cellRendererParams: {
      storeKey: 'view',
      storeName: 'view',
      items: [
        {
          icon: 'hi-eye-icon',
          label: $t('labels.view'),
          class: 'text-blue-600 hover:text-blue-500',
          click: openView
        }
      ]
    }
  }
])

const scheduleMap = ref<any>(null)

const setMapCenter = (vehicle: any) => {
  scheduleMap.value && scheduleMap.value.setVehicleCenter(vehicle)
}
</script>
